"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.JournalActionEnum = exports.ActionTakenEnum = exports.ConcernEnum = exports.TypeEnum = exports.StatusEnum = exports.SourceEnum = void 0;
var SourceEnum;
(function (SourceEnum) {
    SourceEnum["Associate"] = "Associate";
    SourceEnum["Call"] = "Call";
    SourceEnum["Clarification"] = "Clarification";
    SourceEnum["Letter"] = "Letter";
    SourceEnum["Survey"] = "Survey";
})(SourceEnum = exports.SourceEnum || (exports.SourceEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["Open"] = "Open";
    StatusEnum["ClosedWithMerit"] = "ClosedWithMerit";
    StatusEnum["ClosedWithoutMerit"] = "ClosedWithoutMerit";
    StatusEnum["PendingMember"] = "PendingMember";
    StatusEnum["PendingProvider"] = "PendingProvider";
    StatusEnum["New"] = "New";
    StatusEnum["AttemptMade"] = "AttemptMade";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var TypeEnum;
(function (TypeEnum) {
    TypeEnum["Conflict"] = "Conflict";
    TypeEnum["ProviderFirm"] = "ProviderFirm";
    TypeEnum["ProviderReferral"] = "ProviderReferral";
    TypeEnum["EmergencyAccess"] = "EmergencyAccess";
    TypeEnum["SpecialCase"] = "SpecialCase";
})(TypeEnum = exports.TypeEnum || (exports.TypeEnum = {}));
var ConcernEnum;
(function (ConcernEnum) {
    ConcernEnum["UntimelyCallback"] = "UntimelyCallback";
    ConcernEnum["LegalAdvice"] = "LegalAdvice";
    ConcernEnum["Docs"] = "Docs";
    ConcernEnum["StaffAttitude"] = "StaffAttitude";
    ConcernEnum["RetainerOrRate"] = "RetainerOrRate";
    ConcernEnum["ReferralAttorney"] = "ReferralAttorney";
    ConcernEnum["CoverageAdvised"] = "CoverageAdvised";
    ConcernEnum["Disposition"] = "Disposition";
    ConcernEnum["AttorneyNoShow"] = "AttorneyNoShow";
    ConcernEnum["Misc"] = "Misc";
    ConcernEnum["NoReferral"] = "NoReferral";
    ConcernEnum["ImproperPplProcedure"] = "ImproperPplProcedure";
    ConcernEnum["ImproperSoftwareUse"] = "ImproperSoftwareUse";
    ConcernEnum["SurveyScore"] = "SurveyScore";
    ConcernEnum["NoCallback"] = "NoCallback";
    ConcernEnum["AttorneyUnreachable"] = "AttorneyUnreachable";
    ConcernEnum["InsufficientAdvice"] = "InsufficientAdvice";
    ConcernEnum["AreaOrDistance"] = "AreaOrDistance";
    ConcernEnum["AttorneyConflict"] = "AttorneyConflict";
    ConcernEnum["AreaOfLaw"] = "AreaOfLaw";
    ConcernEnum["CaseRefused"] = "CaseRefused";
    ConcernEnum["NewAttorneyReq"] = "NewAttorneyReq";
    ConcernEnum["DiscountRefusal"] = "DiscountRefusal";
})(ConcernEnum = exports.ConcernEnum || (exports.ConcernEnum = {}));
var ActionTakenEnum;
(function (ActionTakenEnum) {
    ActionTakenEnum["WaitingOnProvider"] = "WaitingOnProvider";
    ActionTakenEnum["ProviderActionTaken"] = "ProviderActionTaken";
})(ActionTakenEnum = exports.ActionTakenEnum || (exports.ActionTakenEnum = {}));
var JournalActionEnum;
(function (JournalActionEnum) {
    JournalActionEnum["Migrated"] = "Migrated";
    JournalActionEnum["Created"] = "Created";
    JournalActionEnum["Updated"] = "Updated";
    JournalActionEnum["NoteAdded"] = "NoteAdded";
    JournalActionEnum["StatusUpdated"] = "StatusUpdated";
    JournalActionEnum["AssigneeIdUpdated"] = "AssigneeIdUpdated";
    JournalActionEnum["ContactMethodUpdated"] = "ContactMethodUpdated";
    JournalActionEnum["OwnerChanged"] = "OwnerChanged";
    JournalActionEnum["Redacted"] = "Redacted";
})(JournalActionEnum = exports.JournalActionEnum || (exports.JournalActionEnum = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://resolutions.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Resolutions API
 * @version v1
 * @baseUrl https://resolutions.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags MemberIntakes
             * @name MemberIntakesGetIntakesForMember
             * @request GET:/v1/intakes/{memberid}
             * @secure
             */
            memberIntakesGetIntakesForMember: (memberId, memberid, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/intakes/${memberid}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Permissions
             * @name PermissionsGetAssignees
             * @request GET:/v1/resolutions/assignees
             * @secure
             */
            permissionsGetAssignees: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/assignees`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Permissions
             * @name PermissionsGetOktaGroupMembers
             * @request GET:/v1/resolutions/oktagroup/{groupId}/users
             * @secure
             */
            permissionsGetOktaGroupMembers: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/oktagroup/${groupId}/users`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionHistory
             * @name ResolutionHistoryGetResolutionHistory
             * @request GET:/v1/resolutions/{resolutionId}/history
             * @secure
             */
            resolutionHistoryGetResolutionHistory: (resolutionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${resolutionId}/history`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsGetResolutionResourceById
             * @request GET:/v1/resolutions/{id}
             * @secure
             */
            resolutionsGetResolutionResourceById: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateResolutionResource
             * @request PUT:/v1/resolutions/{id}
             * @secure
             */
            resolutionsUpdateResolutionResource: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsCreateResolutionResource
             * @request POST:/v1/resolutions
             * @secure
             */
            resolutionsCreateResolutionResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsRedactResolutionResource
             * @request POST:/v1/resolutions/{id}/redactPII
             * @secure
             */
            resolutionsRedactResolutionResource: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/redactPII`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsAddNote
             * @request POST:/v1/resolutions/{id}/addNote
             * @secure
             */
            resolutionsAddNote: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/addNote`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateNotePinPriority
             * @request POST:/v1/resolutions/{resolutionId}/note/{noteId}/updatePinPriority/{newPinPriority}
             * @secure
             */
            resolutionsUpdateNotePinPriority: (resolutionId, noteId, newPinPriority, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${resolutionId}/note/${noteId}/updatePinPriority/${newPinPriority}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateStatus
             * @request POST:/v1/resolutions/{id}/updateStatus/{newStatus}
             * @secure
             */
            resolutionsUpdateStatus: (id, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateAssigneeId
             * @request POST:/v1/resolutions/{id}/updateAssigneeId/{newAssigneeId}
             * @secure
             */
            resolutionsUpdateAssigneeId: (id, newAssigneeId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/updateAssigneeId/${newAssigneeId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateContactMethod
             * @request POST:/v1/resolutions/{id}/updateContactMethod/{newContactMethod}
             * @secure
             */
            resolutionsUpdateContactMethod: (id, newContactMethod, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/updateContactMethod/${newContactMethod}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description This modification method requires a machine JWT
             *
             * @tags Resolutions
             * @name ResolutionsChangeOwner
             * @summary Machine JWT Only
             * @request POST:/v1/resolutions/{id}/changeOwner
             * @secure
             */
            resolutionsChangeOwner: (id, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsGetResolutionsByOwner
             * @request GET:/v1/identities/{identityId}/resolutions
             * @secure
             */
            resolutionsGetResolutionsByOwner: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/resolutions`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsDetail
             * @name ResolutionsDetailGetResolutionDetailsById
             * @request GET:/v1/resolutions/{id}/details
             * @secure
             */
            resolutionsDetailGetResolutionDetailsById: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/details`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags ResolutionsJournal
             * @name ResolutionsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/resolutions/journal
             * @secure
             */
            resolutionsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsJournal
             * @name ResolutionsJournalGetJournalMaxClock
             * @request GET:/v1/resolutions/journal/maxClock
             * @secure
             */
            resolutionsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchSearchResolutions
             * @request POST:/v1/resolutions/search
             * @secure
             */
            resolutionsSearchSearchResolutions: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/search`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchResolutionsByProfileId
             * @request GET:/v1/resolutions/getResolutionsByProfileId/{profileId}
             * @secure
             */
            resolutionsSearchResolutionsByProfileId: (profileId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/getResolutionsByProfileId/${profileId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetPartnerBranches
             * @request GET:/v1/resolutions/partnerbranches
             * @secure
             */
            resolutionsSearchGetPartnerBranches: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/partnerbranches`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetFirmEmployeesByFirmId
             * @request GET:/v1/resolutions/firms/{firmid}/employees
             * @secure
             */
            resolutionsSearchGetFirmEmployeesByFirmId: (firmId, firmid, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/firms/${firmid}/employees`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetFirmsByBranchId
             * @request GET:/v1/resolutions/branches/{branchid}/firms
             * @secure
             */
            resolutionsSearchGetFirmsByBranchId: (branchId, branchid, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/branches/${branchid}/firms`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetServicingBranches
             * @request GET:/v1/resolutions/servicingbranches/{memberId}/{entitlementId}
             * @secure
             */
            resolutionsSearchGetServicingBranches: (memberId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/servicingbranches/${memberId}/${entitlementId}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=resolutions.js.map